import { render } from "./index.vue?vue&type=template&id=74b9e6ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=74b9e6ac&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b9e6ac"]])

export default __exports__